import { call, put, takeLatest, all } from 'redux-saga/effects';

import { customerId } from 'common/helpers/tokenHelper';
import { RECORD_EVENT_REQUEST } from 'redux/analytics/constants';
import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';

import { listReservationAvailabilities } from './api';
import {
  LIST_RESERVATION_AVAILABILITIES_REQUEST,
  RESERVATION_AVAILABILITY_LIST_REQUESTING,
  LIST_RESERVATION_AVAILABILITIES_SUCCESS,
  RESET_RESERVATION_AVAILABILITY_ISFETCHING
} from './constants';

function* list(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: RESERVATION_AVAILABILITY_LIST_REQUESTING });
    let { queryString } = action;
    if (customerId()) {
      queryString += `&customerId=${customerId()}`;
    }
    const response = yield call(listReservationAvailabilities, queryString);
    yield put({
      type: LIST_RESERVATION_AVAILABILITIES_SUCCESS,
      payload: response.data
    });
    yield put({
      type: RECORD_EVENT_REQUEST,
      eventName: 'reservationAvailabilityList',
      payload: response.data
    });
    if (action.onSuccess) {
      action.onSuccess();
    }
  } catch (error) {
    yield put({ type: RESET_RESERVATION_AVAILABILITY_ISFETCHING });
    yield call(addAPIError, error);
    if (action.onError) {
      action.onError();
    }
  }
}

function* watchList() {
  yield takeLatest(LIST_RESERVATION_AVAILABILITIES_REQUEST, list);
}

export default function* reservationAvailabilitySagas() {
  yield all([watchList()]);
}
